import { AfterViewInit, Component, ViewChild, ViewContainerRef } from "@angular/core";

import { ICellEditorAngularComp, AgRendererComponent } from "ag-grid-angular";
// import * as moment from 'moment'
import { ICellRendererParams } from "ag-grid/dist/lib/rendering/cellRenderers/iCellRenderer";
// import { IAfterGuiAttachedParams } from "ag-grid/dist/lib/interfaces/iComponent";


@Component({
    selector: 'gridprogressbar',


    template: `<ixsprogressbar [value]= "value"></ixsprogressbar>`,
    // styleUrls:['./gridprogressbar.css']
})
export class IxsgridprogressbarComponent implements AgRendererComponent {

    refresh(params: any): boolean {

        return true;
    }
    agInit(params: ICellRendererParams): void {


        this.params = params;

        this.value = this.params.value;



    }

    private params: any;
    public value: any;


    // @ViewChild('input') public input;




    // getValue(): any {

    //     return this.params.value;
    // }

    // valueChange(data) {

    //     this.params.setValue(this.value);
    // }









}


// WEBPACK FOOTER //
// ./src/app/components/grid/editors/progressbar/gridprogressbar.component.ts